import { Theme03Static } from "components";
import { Theme03 } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.THEME03.path,
      name: "Theme03",
      key: routesMap.THEME03.path,
      commonRoute: false,
      private: true,
      adminAccess: true,
      belongsToSidebar: false,
      element: <Theme03Static />,
    },
    {
      path: `${routesMap.THEME03.path}/:id`,
      name: "Theme03",
      key: `${routesMap.THEME03.path}/:id`,
      commonRoute: true,
      private: true,
      adminAccess: true,
      belongsToSidebar: false,
      element: <Theme03 />,
    },
  ];
}
